import { isOfflineWorkRoute } from "src/app/services/offline-work-route.utils";
import { SESSION } from "src/session.config";
import { HttpErrorPayload, isAuthTokenErrorMessage } from "./http-error-message";

/** Written on logout so other tabs clear session and redirect. */
export const SESSION_REVOKED_AT_KEY = "cbta_session_revoked_at";

export function isAuthFailure(payload: Pick<HttpErrorPayload, "status" | "message" | "errors">): boolean {
	if (payload.status === 401) return true;
	const msg = payload.message ?? payload.errors?.[0] ?? "";
	return isAuthTokenErrorMessage(msg);
}

/** Skip auth error UI: online (silent redirect) or offline on ratings/pending. */
export function shouldSuppressAuthError(
	payload: Pick<HttpErrorPayload, "status" | "message" | "errors">,
): boolean {
	if (!isAuthFailure(payload)) return false;
	if (navigator.onLine) return true;
	return isOfflineWorkRoute(window.location.pathname) && !!localStorage.getItem(SESSION.SESSION_KEY_USER);
}

export function broadcastSessionRevoked(): void {
	try {
		localStorage.setItem(SESSION_REVOKED_AT_KEY, String(Date.now()));
	} catch {
		/* ignore */
	}
}
